import { Injectable } from '@angular/core';
import {
  Auth,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  updatePassword,
  User,
  user,
  UserCredential
} from '@angular/fire/auth';
import { Observable } from 'rxjs';
import { AdminUserService } from './admin-user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  // Observable of the current user
  user$: Observable<User | null>;

  constructor(
    private auth: Auth,
    private adminUserService: AdminUserService
  ) {
    this.user$ = user(this.auth);
  }

  /**
   * Get the current user
   */
  getCurrentUser(): User | null {
    return this.auth.currentUser;
  }

  /**
   * Sign in with email and password
   */
  async signIn(email: string, password: string): Promise<UserCredential> {
    const credential = await signInWithEmailAndPassword(this.auth, email, password);
    return credential;
  }

  /**
   * Sign out
   */
  async signOut(): Promise<void> {
    return await signOut(this.auth);
  }

  /**
   * Create a new user with email and password
   */
  async createUser(email: string, password: string): Promise<UserCredential> {
    return await createUserWithEmailAndPassword(this.auth, email, password);
  }

  /**
   * Send password reset email
   */
  async resetPassword(email: string): Promise<void> {
    return await sendPasswordResetEmail(this.auth, email);
  }

  /**
   * Update user password
   */
  async changePassword(newPassword: string): Promise<void> {
    const currentUser = this.auth.currentUser;
    if (currentUser) {
      return await updatePassword(currentUser, newPassword);
    }
    throw new Error('No user is currently signed in');
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated(): boolean {
    return this.auth.currentUser !== null;
  }
}

